import {SchemaPropertyWithOptionalType} from "common/flowmaster/types/schema";

export default (type: SchemaPropertyWithOptionalType["type"]) =>
  Array.isArray(type) && type.includes("null");
